import {IApiBookingSpace} from "../interfaces/booking-space.interface";
import {BOOKING_SPACE_STATUS} from "../../domain/enum/space-status.enum";

export const bookingSpacesMock: IApiBookingSpace[] = [
  {
    _id: "SPACE-001",
    organization_id: "ORG-001",
    zone_id: "ZONE-001",
    number: 101,
    name: "Sala Principal",
    description: "Sala de conferencias principal",
    capacity: 50,
    status: BOOKING_SPACE_STATUS.AVAILABLE,
    rate_ids: ["RATE-001", "RATE-002"],
    external_slug: "sala-principal",
    external_id: "EXT-001",
    created_at: 1720864800000,
    created_by: "user123",
    updated_at: 1720864800000,
    updated_by: "user123"
  },
  {
    _id: "SPACE-002",
    organization_id: "ORG-001",
    zone_id: "ZONE-001",
    number: 102,
    name: "Sala Ejecutiva",
    description: "Sala de reuniones ejecutiva",
    capacity: 20,
    status: BOOKING_SPACE_STATUS.AVAILABLE,
    rate_ids: ["RATE-003"],
    external_slug: "sala-ejecutiva",
    external_id: "EXT-002",
    created_at: 1720864800000,
    created_by: "user123",
    updated_at: 1720864800000,
    updated_by: "user123"
  },
  {
    _id: "SPACE-003",
    organization_id: "ORG-001",
    zone_id: "ZONE-002",
    number: 103,
    name: "Sala de Capacitación",
    description: "Sala de capacitación y entrenamientos",
    capacity: 30,
    status: BOOKING_SPACE_STATUS.MAINTENANCE,
    rate_ids: ["RATE-001"],
    external_slug: "sala-capacitacion",
    external_id: "EXT-003",
    created_at: 1720864800000,
    created_by: "user123",
    updated_at: 1720864800000,
    updated_by: "user123"
  }
];
